import { Box, Container, Typography, Card, CardContent, Rating, Button } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { motion } from 'framer-motion';

// This is a placeholder component. To enable real Google Reviews:
// 1. Get a Google Places API key from Google Cloud Console
// 2. Enable the Places API
// 3. Create a server-side endpoint to fetch reviews (to keep API key secure)
// 4. Replace this static data with fetched reviews

const GoogleReviews = () => {
  const averageRating = 4.9;
  const totalReviews = 127;

  return (
    <Box sx={{ py: 6, backgroundColor: '#F9FAFB' }}>
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Card sx={{ p: 4, textAlign: 'center', maxWidth: 600, mx: 'auto' }}>
            <CardContent>
              <Typography variant="h4" sx={{ mb: 2, fontWeight: 700 }}>
                Rated Excellent on Google
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, mb: 2 }}>
                <Typography variant="h2" sx={{ fontWeight: 700, color: 'primary.main' }}>
                  {averageRating}
                </Typography>
                <Box>
                  <Rating value={averageRating} precision={0.1} readOnly size="large" />
                  <Typography variant="body2" color="text.secondary">
                    Based on {totalReviews} reviews
                  </Typography>
                </Box>
              </Box>
              <Button
                variant="outlined"
                color="primary"
                size="large"
                href="https://www.google.com/maps"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ mt: 2 }}
              >
                See All Reviews on Google
              </Button>
              <Typography variant="caption" display="block" sx={{ mt: 3, color: 'text.secondary' }}>
                ⚙️ To display real reviews: Connect Google Places API (see README.md)
              </Typography>
            </CardContent>
          </Card>
        </motion.div>
      </Container>
    </Box>
  );
};

export default GoogleReviews;
